import Textfield from "../../../common/components/Textfiled";
import FileUploader from "../../../common/components/FileUploader";
import Button from "../../../common/components/Button";

function FormEvidence({ data, onSubmit, onChange, errors, loading, typeFiles }) {
  return (
    <form onSubmit={onSubmit}>
      <Textfield
        name="date"
        label="Fecha"
        type="date"
        value={data.date}
        onChange={onChange}
        error={errors.date}
      />
      <FileUploader
        name="document"
        label="Documento"
        value={data.document}
        onFileChange={(file) => onChange({ name: "document", value: file })}
        error={errors.document}
        accept={typeFiles}
      />
      <Button type="submit" disabled={loading} loading={loading}>
        Registrar
      </Button>
    </form>
  );
}

export default FormEvidence;
